import { motion } from "framer-motion";

const scrollToForm = () => {
  document.getElementById("assessment-form")?.scrollIntoView({ behavior: "smooth" });
};

const RouteGraphic = () => (
  <svg viewBox="0 0 900 120" fill="none" className="w-full max-w-3xl mx-auto" aria-hidden="true">
    <motion.path
      d="M20 90 C 160 90, 200 30, 340 30 S 520 100, 660 60 S 820 40, 880 40"
      stroke="#e7e5e4"
      strokeWidth="2"
      strokeDasharray="1 10"
      strokeLinecap="round"
    />
    <motion.path
      d="M20 90 C 160 90, 200 30, 340 30 S 520 100, 660 60 S 820 40, 880 40"
      stroke="#ea580c"
      strokeWidth="2.5"
      strokeLinecap="round"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 1.8, ease: "easeOut", delay: 0.4 }}
    />
    <motion.circle cx="20" cy="90" r="6" fill="#fff" stroke="#ea580c" strokeWidth="2.5"
      initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.3, duration: 0.3 }} />
    <motion.circle cx="340" cy="30" r="5" fill="#fff" stroke="#a8a29e" strokeWidth="2"
      initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.9, duration: 0.3 }} />
    <motion.circle cx="660" cy="60" r="5" fill="#fff" stroke="#a8a29e" strokeWidth="2"
      initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.5, duration: 0.3 }} />
    <motion.g initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 2.1, duration: 0.3 }}>
      <circle cx="880" cy="40" r="9" fill="#ea580c" />
      <circle cx="880" cy="40" r="3.5" fill="#fff" />
    </motion.g>
  </svg>
);

const Hero = () => (
  <section data-testid="hero-section" className="relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-16 md:pt-32 md:pb-20 text-center">
      <motion.p
        data-testid="hero-eyebrow"
        className="text-xs font-medium tracking-[0.2em] uppercase text-orange-600 mb-6"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Corporate Transportation Solutions
      </motion.p>
      <motion.h1
        data-testid="hero-headline"
        className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-stone-900 max-w-4xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        Corporate transportation, without the operational headache.
      </motion.h1>
      <motion.p
        data-testid="hero-subtext"
        className="mt-6 text-base md:text-lg text-stone-600 leading-relaxed max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.25 }}
      >
        Tell us what&rsquo;s making business transportation difficult. We&rsquo;ll review your
        requirements and help you find a practical solution.
      </motion.p>
      <motion.div
        className="mt-10 flex flex-col items-center gap-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <button
          onClick={scrollToForm}
          data-testid="hero-cta-button"
          className="rounded-full bg-orange-600 px-8 py-3.5 text-base font-semibold text-white shadow-sm hover:bg-orange-700 hover:-translate-y-px hover:shadow-md transition-[background-color,transform,box-shadow] duration-200"
        >
          Request a Quote
        </button>
        <p data-testid="hero-reassurance" className="text-sm text-stone-500">
          Free initial assessment &bull; No obligation
        </p>
      </motion.div>
      <motion.div
        className="mt-16 md:mt-20"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
        <RouteGraphic />
      </motion.div>
    </div>
  </section>
);

export default Hero;
